import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reusable Breadcrumbs component.
 * @param {Array} items - Array of { label, path } objects. Last item has no path.
 */
const Breadcrumbs = ({ items = [], style }) => {
  return (
    <div className="breadcrumbs" style={style}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.label}>
            {index > 0 && <span className="breadcrumbs__separator">›</span>}
            {isLast ? (
              <span className="breadcrumbs__current">{item.label}</span>
            ) : (
              <Link to={item.path}>{item.label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
